import React from 'react';
import { BrainIcon, MoonIcon, DumbbellIcon, SaladIcon, CalendarCheckIcon, CompassIcon, CheckIcon } from 'lucide-react';
import { tomos, tomoIncluye } from '../data/content';
const icons = {
  brain: BrainIcon,
  moon: MoonIcon,
  dumbbell: DumbbellIcon,
  salad: SaladIcon,
  calendar: CalendarCheckIcon,
  compass: CompassIcon
};
export function TomosSection() {
  return <section className="w-full bg-ink py-16 sm:py-20" aria-labelledby="tomos" data-id="element-169" data-mp="xcw3zht51dra">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-170" data-mp="11dzm6aynrlvo">
        <p className="font-display text-sm font-bold uppercase tracking-[0.28em] text-leaf" data-id="element-171" data-mp="11ehpfrjqn0d3">
          🏆 Reset Integral™
        </p>
        <h2 id="tomos" className="mt-4 font-display text-3xl font-extrabold text-cream sm:text-4xl" data-id="element-172" data-mp="16ff5nyl6tkby">
          Los 6 Tomos del sistema
        </h2>
        <p className="mt-3 max-w-2xl text-[17px] text-cream/65" data-id="element-173" data-mp="2hrzjde64cxf8">
          Seis pilares que se leen en orden y funcionan juntos. Cada uno resuelve
          una parte del problema y sostiene a los demás.
        </p>

        <ol className="mt-10 divide-y divide-ink-600 border-y border-ink-600" data-id="element-174" data-mp="2qlw6njtvw6bx">
          {tomos.map(tomo => {
          const Icon = icons[tomo.icon];
          return <li key={tomo.numeral} className="grid grid-cols-[auto_1fr] items-start gap-x-5 gap-y-2 py-7 sm:grid-cols-[auto_auto_1fr] sm:gap-x-7" data-id="element-175" data-mp="2hlpldbry2227">
                <span className="font-display text-3xl font-extrabold leading-none text-leaf/70 sm:text-4xl" data-id="element-176" data-mp="27qnuaae3ypwz">
                  {tomo.numeral}
                </span>
                <span className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-ink-600 bg-ink-800 sm:flex" data-id="element-177" data-mp="1yy447ybvttnr">
                  <Icon className="h-6 w-6 text-cream" aria-hidden="true" data-id="element-178" data-mp="1tvv8wvbjefih" />
                </span>
                <div data-id="element-179" data-mp="1p0zejoitvg27">
                  <h3 className="font-display text-xl font-bold text-cream sm:text-2xl" data-id="element-180" data-mp="1jzs4tjx4k6sw">
                    {tomo.title}
                  </h3>
                  <p className="mt-2 max-w-2xl text-[15px] leading-relaxed text-cream/65" data-id="element-181" data-mp="1abek8780yubl">
                    {tomo.description}
                  </p>
                </div>
              </li>;
        })}
        </ol>

        <div className="mt-10 rounded-2xl border border-ink-600 bg-ink-800 p-6 sm:p-8" data-id="element-182" data-mp="11dkpv1ttmar2">
          <h3 className="font-display text-base font-bold uppercase tracking-wide text-cream" data-id="element-183" data-mp="15dd1xoifaz16">
            Cada tomo incluye
          </h3>
          <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-184" data-mp="1y1h9ygogvo71">
            {tomoIncluye.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-cream/75" data-id="element-185" data-mp="1kaltojbn24tf">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-leaf" aria-hidden="true" data-id="element-186" data-mp="1oamimxwd5yeq" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}